import styled from "styled-components";

import { CorporateTicketStyledProps as Props } from "./CorporateTicket.types";

const CorporateTicketStyled = styled.div<Props>`
  padding-bottom: 2.4rem;

  .CorporateTicket {
    &__empty {
      padding-top: 5.2rem;
      max-width: 40.8rem;
      margin: 0 auto;
    }

    &__wrapper {
      margin: 2.4rem 0;
      background-color: var(--palette-gray-s0-l30-a40);
      border: 1px dashed var(--palette-gray-s0-l40);
    }

    &__title {
      font-weight: 600;
      font-size: 2.8rem;
      color: var(--palette-light-blue-s10-l60);
      padding-top: 1.6rem;
    }
  }
`;

export default CorporateTicketStyled;
